import { Typography, useTheme } from '@mui/material';
import React, { useMemo } from 'react';

type RequiredDocumentsTotalProps = {
    missingDocumentsCount: number;
    totalCount: number;
    additionnalText?: string;
};
const RequiredDocumentsTotal: React.FunctionComponent<RequiredDocumentsTotalProps> = function ({
    missingDocumentsCount = 0,
    totalCount = 0,
    additionnalText,
}) {
    const { palette } = useTheme();

    const color = useMemo(() => {
        // nbr of uploaded doc === nbr of expected docs
        if (totalCount > 0 && missingDocumentsCount === 0) {
            return palette.success.main;
        }
        // No doc are uploaded
        if (totalCount > 0 && missingDocumentsCount === totalCount) {
            return palette.error.main;
        }

        // Docs partially uploaded
        if (totalCount > 0 && missingDocumentsCount > 0) {
            return palette.warning.main;
        }
        return 'text.gris50';
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [missingDocumentsCount, totalCount]);

    const countDocUploaded = useMemo(() => {
        const uploadedDocNbr = totalCount - missingDocumentsCount;

        if (uploadedDocNbr < 0) {
            return 0;
        }
        return uploadedDocNbr;
    }, [missingDocumentsCount, totalCount]);

    return (
        <Typography
            component="p"
            variant="l2dbodyxs"
            sx={{ color }}
        >
            {countDocUploaded}/{totalCount} {additionnalText}
        </Typography>
    );
};

export default RequiredDocumentsTotal;
